/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttachmentDto } from '../models';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
/**
 * RestAttachmentApi - axios parameter creator
 */
export const RestAttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add attachments
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachmentFile: async (userId: string, resourceId: string, resourceType: ResourceTypeDto, attachment?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addAttachmentFile', 'userId', userId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('addAttachmentFile', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('addAttachmentFile', 'resourceType', resourceType)
            const localVarPath = `/api/resources/{resourceId}/files`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }


            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an attachment
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} externalFileId 
         * @param {string} externalDiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachmentFile: async (userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAttachmentFile', 'userId', userId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteAttachmentFile', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('deleteAttachmentFile', 'resourceType', resourceType)
            // verify required parameter 'externalFileId' is not null or undefined
            assertParamExists('deleteAttachmentFile', 'externalFileId', externalFileId)
            // verify required parameter 'externalDiskId' is not null or undefined
            assertParamExists('deleteAttachmentFile', 'externalDiskId', externalDiskId)
            const localVarPath = `/api/resources/{resourceId}/files/{externalFileId}`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)))
                .replace('{externalFileId}', encodeURIComponent(String(externalFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (externalDiskId !== undefined) {
                localVarQueryParameter['externalDiskId'] = externalDiskId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an attachment
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} externalFileId 
         * @param {string} externalDiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment: async (userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('downloadAttachment', 'userId', userId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('downloadAttachment', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('downloadAttachment', 'resourceType', resourceType)
            // verify required parameter 'externalFileId' is not null or undefined
            assertParamExists('downloadAttachment', 'externalFileId', externalFileId)
            // verify required parameter 'externalDiskId' is not null or undefined
            assertParamExists('downloadAttachment', 'externalDiskId', externalDiskId)
            const localVarPath = `/api/resources/{resourceId}/files/{externalFileId}`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)))
                .replace('{externalFileId}', encodeURIComponent(String(externalFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (externalDiskId !== undefined) {
                localVarQueryParameter['externalDiskId'] = externalDiskId;
            }

            localVarHeaderParameter['Accept'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of attachments
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachments: async (userId: string, resourceId: string, resourceType: ResourceTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAttachments', 'userId', userId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getAttachments', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getAttachments', 'resourceType', resourceType)
            const localVarPath = `/api/resources/{resourceId}/files`
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAttachmentApi - functional programming interface
 */
export const RestAttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add attachments
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, attachment?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAttachmentFile(userId, resourceId, resourceType, attachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAttachmentApi.addAttachmentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an attachment
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} externalFileId 
         * @param {string} externalDiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachmentFile(userId, resourceId, resourceType, externalFileId, externalDiskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAttachmentApi.deleteAttachmentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an attachment
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} externalFileId 
         * @param {string} externalDiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment(userId, resourceId, resourceType, externalFileId, externalDiskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAttachmentApi.downloadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of attachments
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachments(userId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachments(userId, resourceId, resourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAttachmentApi.getAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAttachmentApi - factory interface
 */
export const RestAttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAttachmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Add attachments
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, attachment?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addAttachmentFile(userId, resourceId, resourceType, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an attachment
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} externalFileId 
         * @param {string} externalDiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAttachmentFile(userId, resourceId, resourceType, externalFileId, externalDiskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an attachment
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {string} externalFileId 
         * @param {string} externalDiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAttachment(userId, resourceId, resourceType, externalFileId, externalDiskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of attachments
         * @param {string} userId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachments(userId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<AttachmentDto>> {
            return localVarFp.getAttachments(userId, resourceId, resourceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAttachmentApi - interface
 */
export interface RestAttachmentApiInterface {
    /**
     * 
     * @summary Add attachments
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {File} [attachment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, attachment?: File, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete an attachment
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {string} externalFileId 
     * @param {string} externalDiskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Download an attachment
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {string} externalFileId 
     * @param {string} externalDiskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadAttachment(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get list of attachments
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachments(userId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<AttachmentDto>>;

}

/**
 * RestAttachmentApi - object-oriented interface
 */
export class RestAttachmentApi extends BaseAPI implements RestAttachmentApiInterface {
    /**
     * 
     * @summary Add attachments
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {File} [attachment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, attachment?: File, options?: RawAxiosRequestConfig) {
        return RestAttachmentApiFp(this.configuration).addAttachmentFile(userId, resourceId, resourceType, attachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an attachment
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {string} externalFileId 
     * @param {string} externalDiskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAttachmentFile(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig) {
        return RestAttachmentApiFp(this.configuration).deleteAttachmentFile(userId, resourceId, resourceType, externalFileId, externalDiskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an attachment
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {string} externalFileId 
     * @param {string} externalDiskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAttachment(userId: string, resourceId: string, resourceType: ResourceTypeDto, externalFileId: string, externalDiskId: string, options?: RawAxiosRequestConfig) {
        return RestAttachmentApiFp(this.configuration).downloadAttachment(userId, resourceId, resourceType, externalFileId, externalDiskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of attachments
     * @param {string} userId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAttachments(userId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig) {
        return RestAttachmentApiFp(this.configuration).getAttachments(userId, resourceId, resourceType, options).then((request) => request(this.axios, this.basePath));
    }
}

